import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tieneid;
  tamano = document.body.clientHeight;

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""],
      tipo_rvoe: ["", [Validators.required]],
      rvoe: ["", [Validators.required]],
      id_carrera: ["", [Validators.required]],
      sigla: ["", [Validators.required]],
      tipos_periodos_id: ["", [Validators.required]],
      nombre: ["", [Validators.required]],
      numero_periodos: [9, [Validators.required]],
      //nivel_educativo: ["", [Validators.required]],
      niveles_educativos_id: ["", [Validators.required]],
      fecha_acuerdo: ["", [Validators.required]],
      logo:['']
    });

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

}
